import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Card, CardContent, Typography, Grid, Avatar, Box, Button, Paper } from '@mui/material';
import { MailOutlined, PhoneOutlined, CalendarOutlined, CaretLeftOutlined, UserOutlined } from '@ant-design/icons';

const StudentDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const student = location.state?.student;

  if (!student) {
    return (
      <Box p={4}>
        <Typography variant="h6" color="error" gutterBottom>
          No student data available.
        </Typography>
        <Button variant="outlined" startIcon={<CaretLeftOutlined style={{ fontSize: 18 }} />} onClick={() => navigate(-1)}>
          Back
        </Button>
      </Box>
    );
  }

  return (
    <Box p={4}>
      <Button variant="outlined" startIcon={<CaretLeftOutlined style={{ fontSize: 18 }} />} onClick={() => navigate(-1)} sx={{ mb: 3 }}>
        Back
      </Button>

      <Card elevation={4} sx={{ borderRadius: 3 }}>
        <CardContent>
          {/* Student Header */}
          <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} alignItems="center" mb={3}>
            <Avatar
              alt={student.studentName}
              src={`https://ui-avatars.com/api/?name=${encodeURIComponent(student.studentName)}`}
              sx={{ width: 100, height: 100, mr: { sm: 4 }, mb: { xs: 2, sm: 0 } }}
            />
            <Box>
              <Typography variant="h5" fontWeight={600}>
                {student.studentName}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Student ID: {student.studentId}
              </Typography>
            </Box>
          </Box>

          <Grid container spacing={2}>
            {/* Email */}
            <Grid item xs={12} sm={6}>
              <Paper elevation={2} sx={paperStyle}>
                <MailOutlined style={{ fontSize: 24, color: '#1976d2' }} />
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Email
                  </Typography>
                  <Typography variant="body1">{student.studentEmail || 'N/A'}</Typography>
                </Box>
              </Paper>
            </Grid>

            {/* Phone */}
            <Grid item xs={12} sm={6}>
              <Paper elevation={2} sx={paperStyle}>
                <PhoneOutlined style={{ fontSize: 24, color: '#2e7d32' }} />
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Contact
                  </Typography>
                  <Typography variant="body1">{student.studentContact || 'N/A'}</Typography>
                </Box>
              </Paper>
            </Grid>

            {/* Joined Date */}
            <Grid item xs={12} sm={6}>
              <Paper elevation={2} sx={paperStyle}>
                <CalendarOutlined style={{ fontSize: 24, color: '#ed6c02' }} />
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Joined Date
                  </Typography>
                  <Typography variant="body1">
                    {student.registrationDate ? new Date(student.registrationDate).toLocaleDateString() : 'N/A'}
                  </Typography>
                </Box>
              </Paper>
            </Grid>

            {/* Coach Info */}
            <Grid item xs={12} sm={6}>
              <Paper elevation={2} sx={paperStyle}>
                <UserOutlined style={{ fontSize: 24, color: '#9c27b0' }} />
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Assigned Coach
                  </Typography>
                  <Typography variant="body1">{student.coach_name || 'Not Assigned'}</Typography>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

// Reusable Paper style
const paperStyle = {
  p: 2,
  borderRadius: 2,
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  transition: '0.3s',
  '&:hover': {
    boxShadow: 4
  }
};

export default StudentDetails;
